import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Box, Pagination} from '@mui/material';
import {getAdmins, getBuildings, openModal} from '../actions';
import {Filters, Layout, PageHeader} from '../components';
import AdminsTable from '../components/CustomTables/AdminsTable';
import {usePagination} from '../utils/utilities';
import useFilters from '../utils/useFilters';
import { getAllBuildings } from '../actions/buildingsActions';

const Admins = () => {
  const dispatch = useDispatch();
  const {admins, adminsLoading} = useSelector(s => s.admins);
  const pagination = usePagination(admins);
  const filters = useFilters(val => dispatch(getAdmins(val)));

  const onAddAdmin = () => {
    dispatch(openModal('AddAdminModal'));
  };

  useEffect(() => {
    pagination.onChange(null, 1);
  }, [admins]);

  useEffect(() => {
    dispatch(getAdmins());
    dispatch(getAllBuildings());
  }, []);

  return (
    <Layout>
      <PageHeader onAdd={onAddAdmin} title="Admins" />
      <Filters withSearch {...filters} m="1rem !important" />
      <AdminsTable admins={pagination.dataToShow} loading={adminsLoading} />
      {!!pagination.count && pagination.count > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination {...pagination} />
        </Box>
      )}
    </Layout>
  );
};

export default Admins;
